import React from "react";
import {
  Container,
  Row,
  Col,
} from "reactstrap";

import marketingImg from "assets/img/Trustedby_2.png";

import nasa from "assets/img/trustedby/output2.png";
import usaf from "assets/img/trustedby/USAF_logo.webp";
import dow from "assets/img/trustedby/DOW-Logo.png";
import flag from "assets/img/trustedby/us_flag.webp";

const partners = [
  {
    link: 'https://www.nasa.gov/',
    imageSrc: nasa,
  },
  {
    link: 'https://www.airforce.com/',
    imageSrc: usaf,
  },
  {
    link: 'https://www.war.gov/',
    imageSrc: dow,
  },
  {
    link: '',
    imageSrc: flag,
  }
];

const TrustedBy = () => {
    document.documentElement.classList.remove("nav-open");
  return (
      <div className="section text-center" style={{ position: 'relative' }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${marketingImg})`,
          filter: 'brightness(0.4)',
          zIndex: 0
        }}></div>
        <Container style={{ position: 'relative', zIndex: 1 }}>
            <h1 className="title" style={{ color: 'white', fontWeight: 'bolder'}}>Trusted By</h1> 
            <Row className="justify-content-center">
            <Col md="10" className="mb-5">
                <div style={{ padding: '10px', borderRadius: '10px' }}>
                <Row className="justify-content-center">
                    {partners.map((article, index) => (
                    <Col key={index} lg="4" md="4" sm="4" xs="6" className="mb-3">
                        <a href={article.link} target="_blank" rel="noopener noreferrer">
                        <div
                            style={{
                            width: '100%',
                            height: '120px',
                            borderRadius: '10px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            overflow: 'hidden',
                            }}
                        >
                            <img
                            src={article.imageSrc}
                            alt={`Partner ${index}`}
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                            />
                        </div>
                        </a>
                    </Col>
                    ))}
                </Row>
                </div>
            </Col>
            </Row>
        </Container>
      </div>
  );
}

export default TrustedBy;
